import React, { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const norm = (v) => String(v ?? "").trim();

export default function PayfastCancel() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const tradeIdFromQuery = useMemo(() => norm(params.get("tradeId")), [params]);

  const tradeId = useMemo(() => {
    if (tradeIdFromQuery) return tradeIdFromQuery;
    return norm(sessionStorage.getItem("pf_last_tradeId") || "");
  }, [tradeIdFromQuery]);

  const goTrade = () =>
    tradeId ? navigate(`/trade/${tradeId}?tab=workflow`, { replace: true }) : navigate("/", { replace: true });

  const goCheckout = () =>
    tradeId ? navigate(`/checkout/${tradeId}`, { replace: true }) : navigate("/", { replace: true });

  return (
    <div style={{ maxWidth: 860, margin: "48px auto", padding: "0 16px" }}>
      <div
        style={{
          border: "1px solid #e6e6e6",
          borderRadius: 18,
          background: "#fff",
          padding: 20,
          boxShadow: "0 10px 24px rgba(0,0,0,0.04)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", gap: 14, flexWrap: "wrap" }}>
          <div>
            <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -0.2 }}>Payment Cancelled</div>
            <div style={{ marginTop: 6, opacity: 0.82, lineHeight: 1.5 }}>
              Your PayFast payment was cancelled. No money was secured by the platform. You may retry from checkout.
            </div>
          </div>

          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "6px 10px",
              borderRadius: 999,
              fontSize: 12,
              fontWeight: 900,
              border: "1px solid #d7d7d7",
              background: "#f7f7f7",
            }}
          >
            ↩ Cancelled
          </div>
        </div>

        <div style={{ marginTop: 16, padding: 14, borderRadius: 14, background: "#fafafa" }}>
          <div style={{ fontWeight: 900, marginBottom: 6 }}>Next steps</div>
          <div style={{ fontSize: 13, opacity: 0.86, lineHeight: 1.5 }}>
            If you still want to proceed, return to checkout and submit payment again. The workflow will update only after
            ITN confirmation is received.
          </div>
        </div>

        <div style={{ marginTop: 16, display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button
            onClick={goTrade}
            style={{
              padding: "10px 14px",
              borderRadius: 12,
              border: "1px solid #e6e6e6",
              background: "#fff",
              cursor: "pointer",
              fontWeight: 800,
            }}
          >
            ⬅ Back to trade
          </button>

          <button
            onClick={goCheckout}
            style={{
              padding: "10px 14px",
              borderRadius: 12,
              border: "1px solid #0b7a3a22",
              background: "#0b7a3a0f",
              cursor: "pointer",
              fontWeight: 900,
            }}
          >
            💳 Retry in checkout
          </button>
        </div>

        <div style={{ marginTop: 16, fontSize: 12, opacity: 0.78 }}>
          <div>
            tradeId: <span style={{ fontFamily: "monospace" }}>{tradeId || "—"}</span>
          </div>
        </div>
      </div>
    </div>
  );
}